<ng-container *ngIf="notificationBadgeOptions?.showBadge">
  <cap-notification-badge [showBadge]="!!notificationBadgeOptions?.showBadge" [options]="notificationBadgeOptions">
  </cap-notification-badge>
</ng-container>
